
import { combineReducers } from 'redux';
import editAppKey from './edit-app-key-configuration-reducer';
import productMappings from './product-mappings-reducer';
import extractionSettings from './extraction-settings-reducer';
import llmSettings from './llm-settings-reducer';
import itineraryMining from './itinerary-mining-reducer';
import { findIntegrationApp } from './connection-utils';


const initialState = {
  pageTitle: 'Main',
  toolId: 'itineraryAssist',
  integrationApp: '',
  hint: '', // hint could be "Direct Booking" (text) or the same as partnerId
  partnerId: '',
  partner: {},
  partners: [],
  allAppKeys: [],
};

const withIntegrationApp = state => {
  const toolId = ['Main', 'Product Catalog'].includes(state.pageTitle)
    ? 'itineraryAssist'
    : state.toolId;
  return {
    ...state,
    integrationApp: findIntegrationApp({
      allAppKeys: state.allAppKeys,
      partner: state.partner,
      partners: state.partners,
      partnerId: state.partnerId,
      toolId,
    }),
  };
};

export function metadata(state = initialState, { type, payload, args }) {
  switch(type) {
    case 'genAi_partnerSettings_loadAllAppKeys_SUCCESS':
      return withIntegrationApp({
        ...state,
        allAppKeys: payload.userAppKeys,
      });
    case 'genAi_partnerSettings_updateProps': {
      return withIntegrationApp({ ...state, ...payload });
    }
    case 'genAi_partnerSettings_loadPartner_STARTED':
      return withIntegrationApp({
        ...state,
        partnerId: args[0].partnerId,
      });
    case 'genAi_partnerSettings_loadPartner_SUCCESS':
      return withIntegrationApp({
        ...state,
        partner: payload,
      });
    case 'genAi_partnerSettings_loadPartners_SUCCESS':
      return withIntegrationApp({
        ...state,
        partners: payload.partners,
      });
    default:
      return state;
  }
}



export default combineReducers({
  metadata,
  editAppKey,
  productMappings,
  extractionSettings,
  llmSettings,
  itineraryMining,
})
